class ReadMoreToggle {
  constructor(container) {
    this.container = container;
    this.content = container.querySelector('[data-description]');
    this.fullDescription = this.content.dataset.fullDescription;
    this.truncatedDescription = this.content.dataset.truncatedDescription;
    if (!this.content || !this.fullDescription || !this.truncatedDescription) return;
    this.truncated = true;
    this.render();
  }

  render() {
    this.content.innerHTML = `${this.truncatedDescription} <span class="seo-block__read-more read-more cta">+ ${window.seoBlock.readMore}</span>`;
    this.content.querySelector('.read-more').addEventListener('click', () => this.toggleDescription());
  }

  toggleDescription() {
    this.truncated = !this.truncated;
    this.content.innerHTML = this.truncated
      ? `${this.truncatedDescription} <span class="seo-block__read-more read-more cta">+ ${window.seoBlock.readMore}</span>`
      : `${this.fullDescription} <span class="seo-block__read-more read-more cta">- ${window.seoBlock.readLess}</span>`;
    this.content.querySelector('.read-more').addEventListener('click', () => this.toggleDescription());
    this.container.classList.toggle('truncate', this.truncated);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.seo-block__description').forEach((container) => {
    new ReadMoreToggle(container);
  });
});
